"use client";

import Circle from "../shapes/circle";
import ScrollButton from "../scrollButton";

function Hero() {
  return (
    <div
      id="projectApproach"
      className={`relative snap-start overflow-hidden h-auto min-h-screen bg-palette-neutral-1
            text-palette-dark-4 px-4 md:px-20 pt-32 pb-32 grid place-content-center z-0`}>
      <div className="absolute-center stroke-palette-secondary-2 z-0 flex">
        <Circle
          className="absolute-center w-[70vw] h-[70vw] md:w-[50vw] md:h-[50vw] hidden md:block"
          strokeWidth={0.02}
        />
        <Circle
          className="absolute-center w-[90vw] h-[90vw] md:w-[80vw] md:h-[80vw] hidden md:block"
          strokeWidth={0.01}
        />
      </div>

      <div className="flex flex-col justify-start items-start gap-6 z-10">
        <span className="text-center text-xl md:text-2xl font-semibold">
          Blog
        </span>
        <h1 className="text-6xl lg:text-7xl">
          Our insights on software development and much more in one place.
        </h1>
        <ScrollButton target="#blogs" className="mx-auto" />
      </div>
    </div>
  );
}

export default Hero;
